var map = {
	"./Chart.vue": 366,
	"./Form.vue": 367,
	"./GoogleMap.vue": 368,
	"./List.vue": 369,
	"./Navigation.vue": 370,
	"./Pager.vue": 165,
	"./Slider.vue": 371,
	"./charts/project.vue": 166,
	"./forms/buy-button.vue": 167,
	"./forms/bx24-buy.vue": 168,
	"./forms/bx24-consultation.vue": 169,
	"./forms/bx24-demo.vue": 170,
	"./forms/bx24-discount.vue": 171,
	"./forms/cat-callback.vue": 172,
	"./forms/contacts.vue": 173,
	"./forms/elements/grecaptcha.vue": 8,
	"./forms/form-popup.vue": 174,
	"./forms/form-product-sidebar.vue": 175,
	"./forms/header-callback.vue": 176,
	"./forms/project-callback.vue": 177,
	"./lists/articles.vue": 178,
	"./lists/catalog.vue": 179,
	"./lists/index-articles.vue": 180,
	"./lists/index-news.vue": 181,
	"./lists/index-projects.vue": 182,
	"./lists/more-projects.vue": 183,
	"./lists/portfolio.vue": 184,
	"./maps/bottom.vue": 185,
	"./navigations/top.vue": 186,
	"./sliders/bx24-complex.vue": 187,
	"./sliders/default.vue": 188,
	"./sliders/index-video.vue": 189,
	"./sliders/product_slider.vue": 190,
	"./sliders/project-slider-1.vue": 191,
	"./sliders/project-slider-2.vue": 192,
	"./sliders/smallSlider.vue": 193
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 412;


//////////////////
// WEBPACK FOOTER
// ./src/includes/components ^\.\/.*\.vue$
// module id = 412
// module chunks = 14